import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  makeStyles,
} from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import moment from "moment";
import CSVFile from "../../../../../components/common/ExportCSVFile/CSVFile";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import {
  LeadMessages,
  RedCross,
  SoftwareReleaseEyeIcon,
  SortIcon,
  TickMark,
} from "../../../LeftNav/SvgIcons";
import { MarketingModal } from "../../Marketing/MarketingModal";
import { SupportLeadCompaignView } from "./SupportLeadCompaignView";

const useStyles = makeStyles(theme => ({
  selectedItems: {
    textAlign: "right",
    color: "#8D99A5",
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  gridTable: {
    margin: "20px 0px",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridHeaderInnerCenter: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "4px",
    paddingBottom: "4px",
    textAlign: "center",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridBodyInnerCenter: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
    textAlign: "center",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  gridIconCells: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    "& span": {
      cursor: "pointer",
    },
    csvFile: {
      marginTop: "10px",
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  actionButtons: {
    padding: "unset",
    "&:hover": {
      backgroundColor: "transparent", // Remove background color change on hover
      boxShadow: "none", // Remove box shadow on hover
    },
  },
}));

const SupportInboxGrid = ({
  onOrderBy,
  order,
  LeadsData,
  roomMsgs,
  setRoomMsgs,
  onClearButtonPress,
  setSelectedRoom,
  selectedRoom,
  leadData,
  setLeadData,
  setLoading,
  handleExport,
}) => {
  const classes = useStyles();

  const { hubId } = useSelector(state => state.conversationReducer);
  const [openCampaignModal, setOpenCampaignModal] = useState(null);
  const [openLeadCampaign, setOpenLeadCampaign] = useState(null);

  return (
    <Paper>
      <Grid container justifyContent='flex-start' style={{ marginTop: "10px" }}>
        {/* <div style={{ padding: "10px 0px" }}>
          <CSVFile handleExport={handleExport} />
        </div> */}
      </Grid>
      <Table className={classes.gridTabel}>
        <TableHead className={classes.gridHeader}>
          <TableRow className={classes.gridHeaderRow}>
            <TableCell className={classes.gridHeaderInner}>
              Subject
              <TableSortLabel
                active={order?.orderByKey === "Subject"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "Subject",
                    orderVal: order?.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>

            <TableCell className={classes.gridHeaderInnerCenter}>
              Email
              <TableSortLabel
                active={order?.orderByKey === "FromEmail"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "FromEmail",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Created On
              <TableSortLabel
                active={order?.orderByKey === "CreatedOn"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CreatedOn",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            {/* <TableCell className={classes.gridHeaderInnerCenter}>
              Platform
              <TableSortLabel
                active={order?.orderByKey === "Platform"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "Platform",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell> */}
            {/* <TableCell className={classes.gridHeaderInnerCenter}>
              Contacted
              <TableSortLabel
                active={order?.orderByKey === "IsConnected"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "IsConnected",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell> */}
            <TableCell className={classes.gridHeaderInnerCenter}>
              Quick Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {LeadsData?.length > 0 ? (
            LeadsData.map((item, index) => (
              <TableRow key={index} className='gridBodyRow'>
                <TableCell className={classes.gridBodyInner}>
                  {item.subject || "--"}
                </TableCell>

                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.fromEmail || "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.createdOn
                    ? moment(item.createdOn).format("DD-MM-YYYY")
                    : "--"}
                </TableCell>
                {/* <TableCell className={classes.gridBodyInnerCenter}>
                  {"Email"}
                </TableCell> */}
                {/* <TableCell className={classes.gridBodyInnerCenter}>
                  {item.isConnected ? (
                    <TickMark
                      style={{
                        width: "21",
                        height: "20",
                      }}
                    />
                  ) : (
                    <RedCross
                      style={{
                        width: "21",
                        height: "20",
                      }}
                    />
                  )}
                </TableCell> */}
                <TableCell className={classes.gridIconCells}>
                  <Tooltip title='View Email History' placement='top'>
                    <IconButton
                      className={classes.actionButtons}
                      //   disabled={!item?.isConnected}
                      onClick={() => {
                        setOpenLeadCampaign(item);
                      }}>
                      <SoftwareReleaseEyeIcon
                        style={{
                          fill: "#BADAFB",
                          fill2: "#4EA5FE",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title='Send Email' placement='top'>
                    <IconButton
                      className={classes.actionButtons}
                      onClick={() => {
                        setOpenCampaignModal(item);
                      }}>
                      <OpenInNew
                        style={{
                          color: "rgb(54, 153, 255)",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow key='0' className='gridBodyRow'>
              <TableCell
                colSpan='7'
                className={classes.gridBodyInner}
                style={{ textAlign: "center" }}>
                <span className='emptyGridText'>No Leads Available.</span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <MarketingModal
        open={openCampaignModal}
        setOpen={v => {
          setOpenCampaignModal(v);
        }}
        setLoading={setLoading}
        loadAllCampaigns={() => {
          onClearButtonPress();
        }}
        isSupportInbox={true}
      />
      <SupportLeadCompaignView
        openPopup={openLeadCampaign}
        setOpenPopup={setOpenLeadCampaign}
        setLoading={setLoading}
      />
    </Paper>
  );
};

export default SupportInboxGrid;
